import { render, staticRenderFns } from "./ConversationTab.vue?vue&type=template&id=125d4087&"
import script from "./ConversationTab.vue?vue&type=script&lang=js&"
export * from "./ConversationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports